import "./styles/Device.css";

const Device = () => {
  return (
    <div className="device">
      <div className="left-device">
        <h2>適用於任何裝置</h2>
        <p>
          訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明訂閱優點說明
        </p>
      </div>
      <img src="/Assets/subscription/screen.png" alt="" />
    </div>
  );
};

export default Device;
